var app = angular.module("leonardo");

var OverviewPortfolioStatisticsController = function($scope, $rootScope, $state, $q, $filter, PropertyService,
                                                     FilterService, PermissionService, AccountUserService, ReportService) {

  $scope.permissionService = PermissionService;
  $scope.accountUserService = AccountUserService;
  $scope.portfolio = $scope.$parent.portfolio;
  $scope.properties = [];
  $scope.expanded = false;

  $scope.propertyService = PropertyService;

  $scope.expand = function() {
    var defer = $q.defer();
    if ($scope.expanded) {
      $scope.expanded = false;
      $scope.filter_status = false;
      return;
    }

    PropertyService.getStatus({portfolio__id: $scope.portfolio.id}).then(function(list) {
      $scope.expanded = true;
      $scope.properties = list.results ? list.results : list;
      $scope.properties_aux = angular.copy($scope.properties);
      defer.resolve();
    }, function (error) {
      defer.reject(error);
    });

    return defer.promise;
  };

  $scope.showPropertiesStatus = function(status) {
    $scope.filter_status = true;
    if (!$scope.expanded) {
      $scope.expand().then(function(){
        $scope.properties = $filter('propertyListStatus')($scope.properties_aux, status);
      });
    }
    else {
      $scope.properties = $filter('propertyListStatus')($scope.properties_aux, status);
    }
  };

  $scope.clearFilterStatus = function(){
    $scope.filter_status = false;
    $scope.properties = angular.copy($scope.properties_aux);
  };

  $scope.goToExpired = function(portfolio, property) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    var promise = null;
    if (property) {
      promise = FilterService.setProperty(property);
    }
    else if (portfolio) {
      FilterService.setFilter('portfolio', portfolio.id, true);
      FilterService.removeFilter('property', true);
    }
    $q.when(promise).then(function () {
      $state.go('documents.expired');
    });
  };

  $scope.goToSnoozed = function(portfolio, property) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    var promise = null;
    if (property) {
      promise = FilterService.setProperty(property);
    }
    else if (portfolio) {
      FilterService.setFilter('portfolio', portfolio.id, true);
      FilterService.removeFilter('property', true);
    }
    $q.when(promise).then(function () {
      $state.go('property.tasks.snoozed');
    });
  };

  $scope.goToCannot = function(portfolio, property) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    var promise = null;
    if (property) {
      promise = FilterService.setProperty(property);
    }
    else if (portfolio) {
      FilterService.setFilter('portfolio', portfolio.id, true);
      FilterService.removeFilter('property', true);
    }
    $q.when(promise).then(function () {
      $state.go('property.tasks.cannot');
    });
  };

  $scope.goToActivity = function(portfolio, property) {
    var filters = [];
    FilterService.setFilter('from_date', moment().format('YYYY-MM-DD'), true);
    filters.push('from_date');
    FilterService.setFilter('to_date', moment().subtract(5, 'days').format('YYYY-MM-DD'), true);
    filters.push('to_date');
    FilterService.setFilter('mia', 1, true);
    filters.push('mia');
    if (property) {
      FilterService.setFilter('property_reports', property.id, true);
      filters.push('property_reports');
    }
    else {
      FilterService.removeFilter('property_reports', true);
    }
    if (portfolio) {
      FilterService.setFilter('portfolio_reports', portfolio, true);
      filters.push('portfolio_reports');
    }
    else {
      FilterService.removeFilter('portfolio_reports', true);
    }

    FilterService.setFilter('filters', filters, true);
    ReportService.setQuickReport({ name: "Launch Activity Report", filters: {} });
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $state.go('reports.activity');
  };

};

var OverviewUserListController = function($scope, $controller, AccountUserActivityService) {
  $scope.expanded = false;

  $scope.getEntitiesPromise = function(options) {
    return AccountUserActivityService.getlist(options);
  };

  $scope.expand = function() {
    if ($scope.expanded) {
      $scope.expanded = false;
      return;
    }
    $scope.loadPage(1);
    $scope.expanded = true;
  };

  $controller('TableFilterController', { $scope: $scope });

};

app.controller('OverviewPortfolioStatisticsController', ['$scope', '$rootScope', '$state', '$q', '$filter',
  'PropertyService', 'FilterService', 'PermissionService', 'AccountUserService', 'ReportService',
  OverviewPortfolioStatisticsController]);

app.controller('OverviewUserListController', ['$scope', '$controller', 'AccountUserActivityService',
  OverviewUserListController]);
